import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import TextBlock from "@/components/blocks/TextBlock.vue";
import ContentWrapper from "@/components/generics/ContentWrapper.vue";
import CustomCard from "../generics/CustomCard.vue";
import PageHeader from "../blocks/PageTitle.vue";
import meta from "@/data/meta.json";
import CustomButton from "../generics/CustomButton.vue";
import { router } from "@/router/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

function handleBookClick() {
	router.push({ name: "cardbuy" });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).homepage), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(ContentWrapper, { backgroundImageClass: "background-lavender" }, {
      default: _withCtx(() => [
        _createVNode(PageHeader, { text: "Ditt äventyr som tågluffare börjar här!" }, {
          "main-action": _withCtx(() => [
            _createVNode(CustomButton, { grow: false }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "main-book-button-content",
                  onClick: handleBookClick
                }, " Boka biljett ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(CustomCard, null, {
          default: _withCtx(() => [
            _createVNode(TextBlock, {
              class: "usp-card",
              leadingIcon: "SVG/explore.svg",
              header: "UPPTÄCK",
              content: "Ge dig iväg på ett äventyr du sent lär glömma. Med ett interrailkort kan du nå 31 länder i Europa och resa obegränsat från 5 dagar upp till en hel månad. Som hjälp har du också alla våra guider som kommer se till att äventyret går problem- och bekymmersfritt.",
              fit: true
            })
          ]),
          _: 1
        }),
        _createVNode(CustomCard, null, {
          default: _withCtx(() => [
            _createVNode(TextBlock, {
              class: "usp-card",
              leadingIcon: "SVG/lock.svg",
              header: "SÄKERT",
              content: "Vi är Sveriges äldsta tågluffarplattform och har sedan 2009 arbetat för att förbättra resenärers tågluffarupplevelser. Vi sätter resenärernas intressen först, förbereder för att minimera risken för oväntade problem och är dessutom SSL-certifierade för att garantera säker handel i vår webshop. Med oss kan du känna dig trygga.",
              fit: true
            })
          ]),
          _: 1
        }),
        _createVNode(CustomCard, null, {
          default: _withCtx(() => [
            _createVNode(TextBlock, {
              class: "usp-card",
              leadingIcon: "SVG/swishLogo.svg",
              header: "ENKELT",
              content: "Det är inte bara resan som ska vara enkel, vägen dit också. Därför har vi försökt göra det så enkelt som möjligt för dig att köpa dina tågluffarkort, exempelvis genom att inte göra betalningen besvärligare än att swisha.",
              fit: true
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})